import { Grid, Typography } from '@mui/material';
import { memo } from 'react';

import {
  convertFacadeFinish,
  convertMainFacadeMaterial,
} from '../../../api/characteristics/enumerations';
import {
  ApartmentFramesAndFacades,
  SectionStatus,
} from '../../../api/characteristics/types';
import { SectionStatusBadge } from '../components/StatusIndicators';
import { AnswerTag, AnswerTagsBox, StyledDivider } from '../styles';

interface ApartmentFramesAndFacadesSectionProps {
  formData: ApartmentFramesAndFacades;
  sectionStatus?: SectionStatus;
}

export const ApartmentFramesAndFacadesSection = memo(
  function ApartmentFramesAndFacadesSection({
    formData,
    sectionStatus,
  }: ApartmentFramesAndFacadesSectionProps) {
    return (
      <Grid container spacing={2} marginBottom={3}>
        <Grid item xs={12}>
          <SectionStatusBadge status={sectionStatus} />
        </Grid>
        <Grid item xs={12}>
          <Typography
            fontSize={18}
            fontWeight={600}
            id="frames-fachada-principal"
          >
            Fachada Principal
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Esquadrias</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.main_facade.frames.length > 0 ? (
              formData.main_facade.frames.map((v) => (
                <AnswerTag key={v}>{convertMainFacadeMaterial(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.main_facade.frames_other && (
              <AnswerTag>{formData.main_facade.frames_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Revestimento</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.main_facade.finishes.length > 0 ? (
              formData.main_facade.finishes.map((v) => (
                <AnswerTag key={v}>{convertFacadeFinish(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.main_facade.finishes_other && (
              <AnswerTag>{formData.main_facade.finishes_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>

        <Grid item xs={12}>
          <StyledDivider />
        </Grid>
        <Grid item xs={12}>
          <Typography
            fontSize={18}
            fontWeight={600}
            id="frames-demais-fachadas"
          >
            Demais Fachadas
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Esquadrias</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.other_facades.frames.length > 0 ? (
              formData.other_facades.frames.map((v) => (
                <AnswerTag key={v}>{convertMainFacadeMaterial(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.other_facades.frames_other && (
              <AnswerTag>{formData.other_facades.frames_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Revestimento</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.other_facades.finishes.length > 0 ? (
              formData.other_facades.finishes.map((v) => (
                <AnswerTag key={v}>{convertFacadeFinish(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.other_facades.finishes_other && (
              <AnswerTag>{formData.other_facades.finishes_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
      </Grid>
    );
  }
);
